import { useEffect, useState } from "react";
import { AdminLayout } from "@/components/layout/AdminLayout";
import { api, formatUSD } from "@/lib/api";

export default function AdminPayments() {
  const [txns, setTxns] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/payments");
        setTxns(data);
      } catch (_) {}
    })();
  }, []);

  return (
    <AdminLayout>
      <div className="mb-8">
        <div className="text-[10px] uppercase tracking-[0.4em] text-[#FF2D2D]">Payments</div>
        <h1 className="font-display text-5xl mt-2">Transactions</h1>
      </div>

      <div className="border border-[#262626] divide-y divide-[#262626]" data-testid="payments-list">
        <div className="hidden md:grid grid-cols-12 gap-4 p-4 bg-[#0f0f0f] text-[10px] uppercase tracking-[0.2em] text-[#a3a3a3]">
          <div className="col-span-3">Type</div>
          <div className="col-span-3">Reference</div>
          <div className="col-span-2">Amount</div>
          <div className="col-span-2">Status</div>
          <div className="col-span-2">When</div>
        </div>
        {txns.map((t) => (
          <div key={t.session_id} className="grid grid-cols-12 gap-4 p-4 bg-[#0a0a0a] items-center" data-testid={`txn-${t.session_id}`}>
            <div className="col-span-12 md:col-span-3 text-sm capitalize">{t.type.replace("_", " ")}</div>
            <div className="col-span-6 md:col-span-3 text-xs text-[#a3a3a3] truncate">{t.reference_id}</div>
            <div className="col-span-6 md:col-span-2 text-sm font-semibold">{formatUSD(t.amount)}</div>
            <div className={`col-span-6 md:col-span-2 text-sm capitalize ${t.payment_status === "paid" ? "text-[#FF2D2D]" : "text-[#a3a3a3]"}`}>
              <div className="flex items-center gap-2">
                <span>{t.payment_status}</span>
                {t.payment_status === "paid" && t.webhook_received_at && (
                  <span
                    title={`Webhook confirmed ${new Date(t.webhook_received_at).toLocaleString()}`}
                    className="text-[8px] uppercase tracking-wider px-1 py-0.5 border border-[#FF2D2D]/40 text-[#FF2D2D]"
                  >
                    HOOK
                  </span>
                )}
              </div>
            </div>
            <div className="col-span-6 md:col-span-2 text-xs text-[#a3a3a3]">
              {new Date(t.created_at).toLocaleString()}
            </div>
          </div>
        ))}
        {txns.length === 0 && <div className="bg-[#0a0a0a] p-8 text-center text-[#a3a3a3]">No transactions yet.</div>}
      </div>
    </AdminLayout>
  );
}
